<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Cliente</span>
        <h3 class="page-title d-inline">Editar</h3>
        <d-link v-if="!isCustomer" class="btn btn-success text-white float-right " href="/admin/clientes/novo">Novo cliente</d-link>
        <d-button v-if="!isCustomer" type="button" @click.prevent="save" class="btn-accent float-right mr-2" >Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <customer-page :customer="customer" ref="customerForm"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import CustomerPage from '_modules/customer/components/CustomerPage.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/CustomerModel';

export default {
  name: 'customer-edit',
  components: {
    CustomerPage,
  },
  computed: {
    customer() {
      const { customer } = this.$store.state.customer;
      if (customer) {
        Events.$emit(_LOAD_MODEL_, customer);
        return customer;
      }
      return MODEL;
    },
    isCustomer() {
      const { isCustomer } = this.$store.state.user;
      return isCustomer;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getCustomer',
    ]),
    getCustomerModel() {
      this.setToggle({ type: 'progress', bool: true });
      this.getCustomer(parseInt(this.$route.params.customerId, Number))
        .then(() => {
          this.setToggle({ type: 'progress', bool: false });
        });
    },
    save() {
      this.$refs.customerForm.save();
    },
  },
  mounted() {
    if (this.$route.params.customerId) {
      this.getCustomerModel();
    }
  },
};
</script>

